module.exports = __webpack_public_path__ + "img/icon-caution.a90d4f2f.svg";